import React, { useEffect, useState } from "react"
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd"
import { FormattedMessage, FormattedNumber, injectIntl } from "react-intl"
import "react-phone-number-input/style.css"
import { ConnectedProps, connect } from "react-redux"
import BillingMethodLabel from "../../../product/billing-method/label.component"
import CalendarEvent from "../../../state/calendar-event/CalendarEvent"
import { getPricingTableGroup, getPricingTableSelectedItems } from "../../../state/pricing/selectors"
import { BILLING_METHOD } from "../../../state/product/Types"
import Checkbox from "../../checkbox/checkbox.component"
import Icon from "../../icon/icon.component"
import QuoteGroupName from "../groupname.component.jsx"

type OwnProps = {
    groupItemIds: string[]
    allowEdit: boolean
    groupId: string,
    methods: BILLING_METHOD[],
    sortable: boolean
    objectId: string
    mainObjectId: string
    mainObject: string
    documentCalendarEvents: CalendarEvent[]
    type: string
    providedDragHandleProps: DraggableProvidedDragHandleProps | undefined | null
    isTaxInclusive: boolean
    onUpdateCallback: () => void
    triggerSelectAll: (isChecked: boolean, groupId: string, groupIds: string[]) => void
}


const GroupInformation = (props: Props) => {
    const getGroupIds = (): Set<string> => {
        const groupItemSelectionSetTemp = new Set<string>()
        for (const groupItemId of props.groupItemIds) {
            if (props.itemSelection && props.itemSelection.has(groupItemId)) {
                groupItemSelectionSetTemp.add(groupItemId)
            }
        }

        return groupItemSelectionSetTemp
    }

    const [groupItemSelectionSet, setGroupItemSelectionSet] = useState(getGroupIds())

    useEffect(() => {
        setGroupItemSelectionSet(getGroupIds())
    }, [props.itemSelection, props.groupItemIds])


    const getBillingMethod: () => JSX.Element = () => {
        switch (props.group?.attributes.billingMethod) {
        case BILLING_METHOD.ONE_TIME:
            return <FormattedMessage
                id="quote.item.list.only_one_time_label"
                defaultMessage="One time billing only"
            />
        case BILLING_METHOD.MONTHLY:
            return <FormattedMessage
                id="quote.item.list.only_monthly_label"
                defaultMessage="Monthly billing only"
            />

        case BILLING_METHOD.YEARLY:
            return <FormattedMessage
                id="quote.item.list.only_yearly_label"
                defaultMessage="Yearly billing only"
            />
        default:
            return <></>
        }
    }

    return (<div className={"col-12"}>
        <div className={"quote-item row py-2 bg-light"}>
            <div className={"m-0 p-0 col-12 d-flex"}>
                {props.groupItemIds.length > 0 && props.allowEdit &&
                    <div
                        className={"d-flex mr-3 align-items-center bg-light border-bottom-0"}>
                        <Checkbox
                            title={<FormattedMessage
                                id="quote.item.list.select_all_label"
                                defaultMessage="Select All"
                            />}
                            isPartiallyChecked={(groupItemSelectionSet.size > 0 &&
                                !(groupItemSelectionSet.size == props.groupItemIds.length))}
                            checked={groupItemSelectionSet.size > 0}
                            onChange={(isChecked) => {
                                props.triggerSelectAll(isChecked, props.groupId, props.groupItemIds)
                            }}/>
                    </div>
                }

                <div
                    className={"flex-grow-1 align-self-center quote-group"}>
                    <span
                        className={"mr-3 " + (props.sortable ? "" : "d-none")}>
                        <a href={"#"}
                            className={"sort-handle"}
                            onClick={e => e.preventDefault()}
                            {...props.providedDragHandleProps}>
                            <Icon className={"lead"} value={"bars"}/>
                        </a>
                    </span>

                    <QuoteGroupName
                        showDescription={true}
                        editable={props.allowEdit}
                        value={props.group}
                        objectId={props.objectId}
                        documentId={props.mainObjectId}
                        mainObject={props.mainObject}
                        isRemovable={props.groupItemIds.length === 0}
                        type={props.type}
                        onUpdateCallback={props.onUpdateCallback}
                        documentCalendarEvents={props.documentCalendarEvents}
                    />
                    {!(props.methods.length < 1) && !props.group?.attributes.billingMethod &&
                        <small className={"ml-2"} style={{fontSize: "60%"}}>
                            {getBillingMethod()}
                        </small>
                    }
                </div>

                <div
                    className={"text-secondary align-self-start mt-1 quote-group-title"}>
                    {props.group?.attributes.billingMethod !== BILLING_METHOD.ONE_TIME &&
                        <span
                            className="mr-2 badge badge-pill badge-secondary">
                            <BillingMethodLabel masculine={true}
                                value={props.group?.attributes.billingMethod}/>
                        </span>}
                    <FormattedNumber
                        editable={props.allowEdit}
                        style="currency"
                        currency={props.group?.attributes.currency}
                        value={!props.isTaxInclusive ?
                            props.group?.attributes.subtotalAmount : props.group?.attributes.subtotalAmountInclusive}
                    />
                </div>
            </div>
        </div>
    </div>)
}
const mapState = (state, props: OwnProps) => {
    const id = props.groupId
    const objectId = props.mainObjectId
    return {
        ...props,
        group: getPricingTableGroup(state, id, objectId),
        itemSelection: getPricingTableSelectedItems(state, props.objectId),
    }
}


const mapDispatch = {}
const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(GroupInformation))



// WEBPACK FOOTER //
// ./src/common/quote/component/GroupInformationComponent.tsx